import { useState } from "react";
import { X } from "lucide-react";
import { GALLERY } from "../data/staticData";
import Reveal from "../components/Reveal";

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <div data-testid="page-gallery">
      <section className="container-fld py-20">
        <div className="overline mb-4">// Field Imagery</div>
        <h1 className="font-tactical text-5xl md:text-7xl font-bold uppercase text-white tracking-tight leading-none">
          Inside the <span className="text-[#7CFF00]">Range.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-zinc-400 text-lg leading-relaxed">
          A look inside Frontline Defense training sessions. Real students.
          Real reps.
        </p>
      </section>

      <section className="container-fld pb-24">
        <div
          className="grid grid-cols-2 md:grid-cols-3 gap-3"
          data-testid="gallery-grid"
        >
          {GALLERY.map((src, i) => (
            <Reveal key={src} delay={i * 50}>
              <button
                data-testid={`gallery-item-${i}`}
                onClick={() => setActive(src)}
                className="block w-full aspect-square overflow-hidden border border-white/10 hover:border-[#7CFF00] transition-all group relative"
              >
                <img
                  src={src}
                  alt={`Gallery ${i + 1}`}
                  className="w-full h-full object-cover grayscale-[20%] group-hover:grayscale-0 group-hover:scale-110 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors" />
                <div className="absolute bottom-2 left-2 font-mono-tactical text-[10px] text-[#7CFF00] uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity">
                  // FRAME {String(i + 1).padStart(3, "0")}
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </section>

      {active && (
        <div
          data-testid="gallery-lightbox"
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[70] bg-black/95 flex items-center justify-center p-4 backdrop-blur-sm"
        >
          <button
            onClick={() => setActive(null)}
            className="absolute top-6 right-6 text-white hover:text-[#7CFF00]"
            aria-label="Close"
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={active}
            alt="Expanded"
            className="max-w-full max-h-full object-contain border border-[#7CFF00]/50"
          />
        </div>
      )}
    </div>
  );
}
